module.exports = __webpack_public_path__ + "img/icon-clock.334781a7.svg";